import { api } from '@/api'

type ImageUploadResponce = {
  imageId: number
  imageUrl: string
  success: boolean
}

type AddDeviceImageResponse = {
  success: boolean
  id: string
  imgUrl: string
}

const uploadImgService = api.injectEndpoints({
  endpoints: (build) => ({
    UploadFeaturesImage: build.mutation<ImageUploadResponce, FormData>({
      query: (body) => ({
        url: '/devices/addLightingImage',
        method: 'POST',
        body,
      }),
    }),
    DeleteFeaturesImage: build.mutation<
      ImageUploadResponce,
      { deviceId: number }
    >({
      query: (body) => ({
        url: '/devices/deleteLightingImage',
        method: 'POST',
        body,
      }),
    }),
    addDeviceImage: build.mutation<AddDeviceImageResponse, FormData>({
      query: (body) => ({
        url: '/devices/addDeviceImage',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const {
  useUploadFeaturesImageMutation,
  useDeleteFeaturesImageMutation,
  useAddDeviceImageMutation,
} = uploadImgService
